export default __webpack_public_path__ + "static/media/soilsImage.6e4c6aee.png";